"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicButtonStyles = void 0;
var core_1 = require("@material-ui/core");
var commons_1 = require("../../../../style/commons");
exports.BasicButtonStyles = (0, core_1.makeStyles)(function () { return ({
    button: {
        backgroundColor: commons_1.darkBlue,
        color: commons_1.white,
        fontSize: '16px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        padding: '8px 16px',
        height: '40px',
        margin: '8px',
        '&:hover': {
            backgroundColor: commons_1.darkMediumBlue,
        },
    },
    buttonDisabled: {
        color: commons_1.white + ' !important',
        opacity: 0.4,
    },
}); });
